  import axios from "axios";
  import { decorateApiError } from "../../utils/apiErrorUtils";

  const instance = axios.create({
    baseURL: process.env.REACT_APP_DOMAIN + "/api/"
    //  baseURL: "http://34.135.58.98:5005/api/",
  // baseURL: "https://pbp.morningwalkusa.com/api",
        //  baseURL: "https://pbp.morningwalkusa.com/api", //production  
  });

  instance.interceptors.request.use((config) => {
    const token = localStorage.getItem("authToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      delete config.headers.Authorization;
    }
    return config;
  });

  instance.interceptors.response.use(
    (response) => response,
    (error) => Promise.reject(decorateApiError(error)),
  );

  export default instance;
